import React, { useState, useEffect, useMemo } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import drilldown from 'highcharts/modules/drilldown';
import Select from 'react-select';
import redirectURL from "../redirectURL"

drilldown(Highcharts);

const topOptions = [
  { value: 3, label: 'Top 3' },
  { value: 5, label: 'Top 5' }
];

const CFAPieChartWithDrilldown = ({ chartData,startDate, endDate}) => {
  const [selectedTop, setSelectedTop] = useState(topOptions[2]); // Default to Top 5
  const [rawData ,setRawData] = useState(chartData)
  
    // Add date state (but do not filter chart by date)
    const [fromDate, setFromDate] = useState(startDate);
    const [toDate, setToDate] = useState(endDate);
    const [loading, setLoading] = useState(false);
    const [dates, setDates] = useState([]);
  
   useEffect(() => {
  const fetchData = async () => {
    setLoading(true);
    try {
      const params = {
        from_date: fromDate,
        to_date: toDate,
      };

      const dailySalesResponse = await redirectURL.post("inventory/getTop5DestinationWiseChartData", params);
      
      if (dailySalesResponse.status === 200) {
        if (dailySalesResponse.data.status === "success") {
          setRawData(JSON.parse(dailySalesResponse.data.data.drilldown_df) || []);
        }
      }
    } catch (err) {
      alert('Failed to call API');
    } finally {
      setLoading(false);
    }
  };

  fetchData();
}, [fromDate, toDate, topOptions]);



  const { mainSeries, drilldownSeries } = useMemo(() => {
    if (!rawData || rawData.length === 0) {
      return { mainSeries: [], drilldownSeries: [] };
    }

    const storeTotals = {};
    const drilldownMap = {};

    rawData.forEach(({ sku_code, destination_store_name, sale_quantity }) => {
      storeTotals[destination_store_name] = (storeTotals[destination_store_name] || 0) + sale_quantity;

      if (!drilldownMap[destination_store_name]) {
        drilldownMap[destination_store_name] = {};
      }

      drilldownMap[destination_store_name][sku_code] =
        (drilldownMap[destination_store_name][sku_code] || 0) + sale_quantity;
    });

    // const topCount = selectedTop?.value || 7;

    const topStores = Object.entries(storeTotals)
      .sort((a, b) => b[1] - a[1])
      // .slice(0, topCount);

    const mainSeries = topStores.map(([store, qty]) => ({
      name: store,
      y: qty,
      drilldown: store,
    }));

  const drilldownSeries = topStores.map(([store]) => ({
    id: store,
    name: `SKUs in ${store}`,
    data: Object.entries(drilldownMap[store]).map(([sku, qty]) => [`SKU: ${sku}`, qty]),
  }));



    return { mainSeries, drilldownSeries };
  }, [selectedTop, rawData]);

  const chartOptions = {
    chart: {
      type: 'column',
      height : "500px"
    },
    title: {
      text: 'Sales Summary (Destination Store Wise)',
    },

    xAxis: {
      type: 'category',
      // title: { text: 'SKU Code' },
    },
    yAxis: {
      title: { text: 'Sale Quantity' },
      labels: {
        formatter() {
          return this.value / 1000 + 'k';
        },
      },
    },
    credits: { enabled: false },
        tooltip: {
          headerFormat: '<b>{series.name}</b><br>',
          pointFormat: '{point.name}: <b>{point.y}</b>',
        },
        plotOptions: {
          column: {
            dataLabels: {
              enabled: true,
              format: '{point.y}',
            },
          },
        },
        series: [
          {
            name: 'Stores',
            colorByPoint: true,
            data: mainSeries,
          },
        ],
        drilldown: {
          series: drilldownSeries,
        },
      };
    

  return (
    <div style={{ padding: '20px' }}>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 24, marginBottom: 24 }}>
        {/* <div style={{ width: '200px'}}>
          <label style={{ fontWeight: 'bold' }}>Select Top Stores</label>
          <Select
            options={topOptions}
            value={selectedTop}
            onChange={setSelectedTop}
            placeholder="Top N Stores"
          />
        </div> */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          <label style={{ fontWeight: 600, fontSize: 16, marginBottom: 4 }}>From Date:</label>
          <input
            id="from-date-pieChart"
            type="date"
            value={fromDate}
            min={startDate}
            max={toDate}
            onChange={e => setFromDate(e.target.value)}
            style={{
              padding: '6px 12px',
              borderRadius: 4,
              border: '1px solid #ccc',
              fontSize: 14,
              background: '#fff',
              marginBottom: 0,
              minWidth: 140
            }}
            onClick={() => {
              const dateInput = document.getElementById('from-date-pieChart');
              if (dateInput && dateInput.showPicker) {
                dateInput.showPicker();
              }
            }}
            // disabled={allDates.length === 0}
          />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
            <label style={{ fontWeight: 600, fontSize: 16, marginBottom: 4 }}>To Date:</label>
            <input
              id="to-date-pieChart"
              type="date"
            value={toDate}
            min={fromDate}
            max={endDate}
              onChange={e => setToDate(e.target.value)}
              style={{
                padding: '6px 12px',
                borderRadius: 4,
                border: '1px solid #ccc',
                fontSize: 14,
                background: '#fff',
                marginBottom: 0,
                minWidth: 140
              }}
              onClick={() => {
              const dateInput = document.getElementById('to-date-pieChart');
              if (dateInput && dateInput.showPicker) {
                dateInput.showPicker();
              }
            }}
              // disabled={allDates.length === 0} 
            />
          </div>
      </div>

      <HighchartsReact highcharts={Highcharts} options={chartOptions} />
    </div>
  );
};

export default CFAPieChartWithDrilldown;
